import { Outlet } from "react-router-dom";
import "./App.css";
import AppComponents from "./AppComponents";
import Footer from "./components/common/Footer";
import Header from "./components/common/Header";
import "./variables.css";

function App() {
  return (
    <div>
      <AppComponents />
      <Header />
      <div className="main-content-h">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default App;
